// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tags-inline{font-size:22px;color:#fff;opacity:.85;margin-top:20px}.tags-inline--item{cursor:pointer;font-weight:700;margin:0 15px}.tags-inline--more{border-left:3px solid #fff;padding-left:30px}", ""]);
// Exports
module.exports = exports;
